module.exports = __webpack_public_path__ + "img/map_suite-locations_legacy.cee743b1.jpg";